import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const myPoundSaverStylesUK: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_BODY: 'bg-white',
  COMMONS_APPBAR_BG: 'bg-[#017DF1]',
  COMMONS_APPBAR_TEXT: 'text-white',
  COMMONS_APPBAR_SIDE_MENU_CLOSE_ICON: 'fill-white',
  COMMONS_APPBAR_MENU_BURGER: '[&>.burger-line]:stroke-white',
  COMMONS_FOOTER_BG: 'bg-[#017DF1]',
  COMMONS_FOOTER_TEXT: 'text-white',
  COMMONS_WIDGETS_SEARCH_ICON: '[&>g>path]:fill-white',
  COMMONS_WIDGETS_SEARCH_SUBMIT: 'bg-[#EB288F] [&>svg>path]:stroke-white',
  COMMONS_WIDGETS_SEARCH_SHADOW: '',
  HOMEPAGE_HEADER_BG: 'bg-[#FFF6F2]',
  HOMEPAGE_HEADER_TEXT: 'text-black',
  HOMEPAGE_HEADER_TITLE_DOT: 'after:text-[#017DF1]',
  HOMEPAGE_HEADER_ICON_FILL: 'fill-black',
  HOMEPAGE_HEADER_ICON_STROKE: '[&>path]:stroke-white',
  HOMEPAGE_TOPRATED_BUTTON: 'border-[#EB288F] hover:border-[#EB288F] hover:bg-[#EB288F] hover:text-white text-black',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#f0c52b]',
  HOMEPAGE_HEADER_TITLE_STAR: 'before:text-[#EA413B]',
  HOMEPAGE_RANK_BANNER_BG: 'bg-[#017DF1]',
  HOMEPAGE_RANK_BANNER_TEXT: 'text-white',
  HOMEPAGE_CATEGORIES_CARD_BORDER: 'border-[#017DF1]',
  HOMEPAGE_TOP_DISCOUNTED_BG: 'bg-[#EA413B]',
  HOMEPAGE_BUTTON_PRIMARY:
    'bg-[#78C02A] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_SECONDARY:
    'border-[#017DF1] text-[#017DF1] [&>svg>path]:stroke-[#017DF1] [&>svg>g>path]:stroke-[#017DF1] [&>svg>path]:fill-[#017DF1] [&>svg>g>path]:fill-[#017DF1]',
  HOMEPAGE_BUTTON_ARROW_BG: 'bg-[#EB288F]',
  HOMEPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  HOMEPAGE_DID_YOU_KNOW_CTA: 'bg-[#017DF1]',
  HOMEPAGE_DID_YOU_KNOW_BG: 'bg-[#FFF6F2]',
  HOMEPAGE_DID_YOU_KNOW_TEXT: 'text-black',
  HOMEPAGE_ON_SALE_CTA: 'bg-[#EA413B]',
  HOMEPAGE_EXPLORE_BANNER_BG: 'bg-[#FFF6F2]',
  HOMEPAGE_EXPLORE_BANNER_TEXT: 'text-black',
  HOMEPAGE_EXPLORE_BANNER_TEXT_STAR: 'before:text-black',
  HOMEPAGE_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#017DF1] [&>.explore-icon-fill]:!fill-[#FFF6F2] [&>g>.explore-icon-fill]:!fill-[#FFF6F2]',
  HOMEPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#FFF6F2] [&>.vector-top>path]:fill-[#017DF1] [&>.vector-bottom>path]:fill-[#017DF1]',

  CARD_BORDER: 'border-[#78C02A]',
  LISTPAGE_USER_VALUE_BADGE: 'text-gray-900 [&>div>svg>path]:fill-[#030303] bg-gray-200',
  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#FFC800]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-white',
  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#EB288F]',
  LISTPAGE_BADGE_SPONSORED_TEXT: 'text-white',
  LISTPAGE_BADGE_WINNER_BG: 'bg-[#EB288F]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-white',
  LISTPAGE_BADGE_WINNER_DIVIDER: '!divide-white',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#EB288F]',
  LISTPAGE_BADGE_BEST_VALUE_TEXT: 'text-white',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '!divide-white',

  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#EA413B]',
  LISTPAGE_BADGE_CARD_DISCOUNT_TEXT: 'text-white',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#FFF6F2]',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: '!text-[#017DF1]',

  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-[#FFF6F2]',
  LISTPAGE_BADGE_CTA_DISCOUNT_TEXT: 'text-black',
  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#017DF1]',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-[#017DF1]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-[#FFF6F2]',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_TEXT: 'text-black',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_ICON: '[&>svg>g>g>g>.fill-current]:!fill-black',
  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#78C02A]',
  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#78C02A] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#017DF1] text-[#017DF1] [&>svg>path]:stroke-[#017DF1] [&>svg>g>path]:stroke-[#017DF1] [&>svg>path]:fill-[#017DF1] [&>svg>g>path]:fill-[#017DF1]',
  LISTPAGE_BUTTON_LINK: 'text-[#EB288F]',
  LISTPAGE_ANCHOR_LINK: 'text-[#78C02A]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#EB288F]',
  LISTPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#EB288F]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#EB288F]',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-green-500 text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-green-500 text-green-500  [&>svg>path]:stroke-green-500 [&>svg>g>path]:stroke-green-500 [&>svg>path]:fill-green-500 [&>svg>g>path]:fill-green-500',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-green-500',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-green-500',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-green-500',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-green-500',
  LISTPAGE_SPONSORED_CARD_BORDER: 'tablet:border-lime-500',
  LISTPAGE_TOP_PICKS_SPECS_CARD_BORDER: 'tablet:border tablet:border-gray-400',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_TEXT: 'text-black',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_BORDER: 'border-[#78C02A]',
  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#FFD94D] [&>.vector-top>path]:fill-[#017DF1] [&>.vector-bottom>path]:fill-[#017DF1]',
  LISTPAGE_WIDGETS_RELATED_PRODUCTS_BG: 'bg-neutral-100',
  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-[#FFF6F2] [&>circle]:stroke-[#FFF6F2] [&>path]:fill-[#017DF1]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-[#FFF6F2]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_ICON: '[&>svg]:fill-[#EB288F]',
  LISTPAGE_WIDGETS_SORT_BY_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SORT_BY_OPTION: 'data-[focus]:bg-[#FFF6F2] data-[focus]:text-[#78C02A]',
  LISTPAGE_WIDGETS_SORT_BY_SELECTED_OPTION: 'bg-[#FFF6F2]',
  LISTPAGE_WIDGETS_SORT_BY_CURRENT_OPTION_LABEL: 'font-medium text-[#78C02A]',
  LISTPAGE_WIDGETS_AFFILIATEDISCLOSURE_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SHAREMENU_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_DISCLAIMER_INFO_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_BG: 'bg-amber-200',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_TEXT: 'text-black',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#FBBF24] [&>.explore-icon-fill]:!fill-[#92400E] [&>g>.explore-icon-fill]:!fill-[#92400E]',

  UTILS_MAIN_CONTAINER: 'content-container',
}
